export default __webpack_public_path__ + "4ef1ccef94e3202cd0130f45e2d7792f.svg";